import { forwardRef, type SVGProps } from 'react';

export const DeclinedIconLight = forwardRef<
  SVGSVGElement,
  SVGProps<SVGSVGElement>
>(function DeclinedIconLight(props, ref) {
  return (
    <svg
      ref={ref}
      fill="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="12" cy="12" fill="white" r="11.5" stroke="#D33E43" />
      <path
        d="M7.04353 7.04353C7.23153 6.85558 7.48648 6.75 7.75232 6.75C8.01815 6.75 8.2731 6.85558 8.46111 7.04353L12.0061 10.5885L15.551 7.04353C15.7401 6.86091 15.9933 6.75986 16.2562 6.76214C16.519 6.76443 16.7705 6.86986 16.9564 7.05574C17.1422 7.24162 17.2477 7.49306 17.25 7.75592C17.2522 8.01878 17.1512 8.27203 16.9686 8.46111L13.4236 12.0061L16.9686 15.551C17.1512 15.7401 17.2522 15.9933 17.25 16.2562C17.2477 16.519 17.1422 16.7705 16.9564 16.9564C16.7705 17.1422 16.519 17.2477 16.2562 17.25C15.9933 17.2522 15.7401 17.1512 15.551 16.9686L12.0061 13.4236L8.46111 16.9686C8.27203 17.1512 8.01878 17.2522 7.75592 17.25C7.49306 17.2477 7.24162 17.1422 7.05574 16.9564C6.86986 16.7705 6.76443 16.519 6.76214 16.2562C6.75986 15.9933 6.86091 15.7401 7.04353 15.551L10.5885 12.0061L7.04353 8.46111C6.85558 8.2731 6.75 8.01815 6.75 7.75232C6.75 7.48648 6.85558 7.23153 7.04353 7.04353Z"
        fill="#D33E43"
      />
    </svg>
  );
});
